module.exports = __webpack_public_path__ + "static/media/GP_2_Press.7ec134fd.jpg";